<template>
  <div style="background-color: #f6f6f6;">
    <Header />
    <div id="account">
      <div class="account_content">
<!--        <div class="navigationMenu">-->
<!--          <div class="nav_title">个人中心</div>-->
<!--          <div v-for="item in menuList" :key="item.key" class="nav_list" :class="{'active-name': activeKey === item.key}" @click="cardClick(item)">{{ item.name }}</div>-->
<!--        </div>-->

        <!-- 个人中心容器 -->
        <div class="profile-container">
          <!-- 侧边栏菜单 -->
          <div class="sidebar">
            <div class="user-card">
              <div class="avatar-large">{{ userInfo?.userName?.slice(0,1) }}</div>
              <div class="user-name">{{ userInfo.userName }}</div>
              <div class="user-id">工号: {{ userInfo.jobNumber }}</div>
              <div class="total-points">
                <i><img src="@/assets/icon/jifen.png" style="width: 15px;margin-bottom: 2px;" /></i>
                <span>{{ userInfo.points }} 积分</span>
              </div>
            </div>


            <div class="menu-list">
              <div :class="activeKey === item.key ? 'menu-item active' : 'menu-item'" v-for="item in menuList" :key="item.key" @click="cardClick(item)">
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>

          <!-- 主内容区域 -->
          <div class="main-content">
            <Integral v-if="activeKey === 'integral'"/>
            <Order v-if="activeKey === 'order'"/>
            <Address v-if="activeKey === 'address'"/>
          </div>
        </div>

<!--        <div class="content_box">-->
<!--          <Integral v-if="activeKey === 'integral'"/>-->
<!--          <Order v-if="activeKey === 'order'"/>-->
<!--          <Address v-if="activeKey === 'address'"/>-->
<!--        </div>-->
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Order from './modules/Order'
import Integral from './modules/Integral'
import Address from './modules/Address'
import Footer from '@/components/Footer'
import {loadPoints} from "@/api/account";
export default {
  components: {
    Header,
    Order,
    Integral,
    Address,
    Footer
  },
  data () {
    return {
      userInfo: {},
      menuList: [
        {
          key: 'integral',
          name: '积分明细'
        },
        {
          key: 'order',
          name: '我的订单'
        },
        {
          key: 'address',
          name: '收货地址'
        }
      ],
      activeKey: 'integral'
    }
  },
  mounted () {
    this.getPoints()
    this.activeKey = this.$route.query?.key || 'integral'
  },
  methods: {
    getPoints () {
      loadPoints().then(res => {
        this.userInfo = res.data
      })
    },
    cardClick (item) {
      this.$router.push({
        path: `/account`,
        query: {
          key: item.key
        }
      })
      this.activeKey = item.key
    }
  }
}
</script>
<style lang="less" scoped>

/* 个人中心容器 */
.profile-container {
  max-width: 1200px;
  margin: 30px auto;
  display: flex;
  gap: 20px;
}

/* 侧边栏菜单 */
.sidebar {
  width: 250px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  padding: 20px 0;
}

.user-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #f0f4f8;
}

.avatar-large {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #84fab0, #8fd3f4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: white;
  margin-bottom: 15px;
}

.user-name {
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 5px;
}

.user-id {
  color: #7f8c8d;
  font-size: 14px;
  margin-bottom: 10px;
}

.total-points {
  background: linear-gradient(135deg, #ffecd2, #fcb69f);
  padding: 8px 20px;
  border-radius: 30px;
  font-weight: 700;
  color: #e74c3c;
  display: flex;
  align-items: center;
  gap: 8px;
}

.total-points i {
  color: #ffd700;
}

.menu-list {
  padding: 15px 0;
}

.menu-item {
  padding: 12px 25px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  //transition: all 0.3s ease;
}

.menu-item:hover, .menu-item.active {
  background: rgba(161, 196, 253, 0.1);
  border-left: 3px solid #a1c4fd;
  color: #2c3e50;
}

.menu-item i {
  width: 20px;
  text-align: center;
  color: #7f8c8d;
}

.menu-item.active i, .menu-item:hover i {
  color: #a1c4fd;
}

/* 主内容区域 */
.main-content {
  flex: 1;
  width: 1000px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  padding: 30px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
  position: relative;
  padding-bottom: 10px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #ff9a9e, #fad0c4);
  border-radius: 2px;
}

.filter-options {
  display: flex;
  gap: 10px;
}

.filter-btn {
  background: white;
  border: 1px solid #e0e6ed;
  padding: 8px 15px;
  border-radius: 30px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.filter-btn:hover, .filter-btn.active {
  background: linear-gradient(135deg, #ffecd2, #fcb69f);
  color: #2c3e50;
  border-color: transparent;
}

/*
  --------------------------
*/

#account {
  width: 1200px;
  margin: 20px auto;
}
.account_content {
  display: flex;
  align-items: flex-start;
  .navigationMenu {
    width: 180px;
    min-height: 820px;
    background: #fff;
    border-radius: 10px;
    margin-right: 20px;
    .nav_title{
      color: #1890ff;
      font-weight: 550;
      font-size: 18px;
      height: 50px;
      line-height: 50px;
      align-items: center;
      padding-left: 20px;
    }
    .nav_list {
      padding-left: 30px;
      font-size: 14px;
      font-weight: 700;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      &.active-name{
        color: #1890ff;
      }
    }
  }
  .content_box{
    flex: 1;
  }
}
</style>
